import { __extends } from "tslib";
import { WebXRFeaturesManager, WebXRFeatureName } from "../webXRFeaturesManager";
import { Observable } from "../../Misc/observable";
import { WebXRAbstractFeature } from "./WebXRAbstractFeature";
/**
 * A module that will automatically disable background meshes when entering AR and will enable them when leaving AR.
 */
var WebXRBackgroundRemover = /** @class */ (function (_super) {
    __extends(WebXRBackgroundRemover, _super);
    /**
     * constructs a new background remover module
     * @param _xrSessionManager the session manager for this module
     * @param options read-only options to be used in this module
     */
    function WebXRBackgroundRemover(_xrSessionManager, 
    /**
     * read-only options to be used in this module
     */
    options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, _xrSessionManager) || this;
        _this.options = options;
        /**
         * registered observers will be triggered when the background state changes
         */
        _this.onBackgroundStateChangedObservable = new Observable();
        return _this;
    }
    /**
     * attach this feature
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */
    WebXRBackgroundRemover.prototype.attach = function () {
        this._setBackgroundState(false);
        return _super.prototype.attach.call(this);
    };
    /**
     * detach this feature.
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */
    WebXRBackgroundRemover.prototype.detach = function () {
        this._setBackgroundState(true);
        return _super.prototype.detach.call(this);
    };
    /**
     * Dispose this feature and all of the resources attached
     */
    WebXRBackgroundRemover.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this.onBackgroundStateChangedObservable.clear();
    };
    WebXRBackgroundRemover.prototype._onXRFrame = function (_xrFrame) {
        // no-op
    };
    WebXRBackgroundRemover.prototype._setBackgroundState = function (newState) {
        var scene = this._xrSessionManager.scene;
        if (!this.options.ignoreEnvironmentHelper) {
            if (this.options.environmentHelperRemovalFlags) {
                if (this.options.environmentHelperRemovalFlags.skyBox) {
                    var backgroundSkybox = scene.getMeshByName("BackgroundSkybox");
                    if (backgroundSkybox) {
                        backgroundSkybox.setEnabled(newState);
                    }
                }
                if (this.options.environmentHelperRemovalFlags.ground) {
                    var backgroundPlane = scene.getMeshByName("BackgroundPlane");
                    if (backgroundPlane) {
                        backgroundPlane.setEnabled(newState);
                    }
                }
            }
            else {
                var backgroundHelper = scene.getMeshByName("BackgroundHelper");
                if (backgroundHelper) {
                    backgroundHelper.setEnabled(newState);
                }
            }
        }
        if (this.options.backgroundMeshes) {
            this.options.backgroundMeshes.forEach(function (mesh) { return mesh.setEnabled(newState); });
        }
        this.onBackgroundStateChangedObservable.notifyObservers(newState);
    };
    /**
     * The module's name
     */
    WebXRBackgroundRemover.Name = WebXRFeatureName.BACKGROUND_REMOVER;
    /**
     * The (Babylon) version of this module.
     * This is an integer representing the implementation version.
     * This number does not correspond to the WebXR specs version
     */
    WebXRBackgroundRemover.Version = 1;
    return WebXRBackgroundRemover;
}(WebXRAbstractFeature));
export { WebXRBackgroundRemover };
//register the plugin
WebXRFeaturesManager.AddWebXRFeature(WebXRBackgroundRemover.Name, function (xrSessionManager, options) {
    return function () { return new WebXRBackgroundRemover(xrSessionManager, options); };
}, WebXRBackgroundRemover.Version, true);
//# sourceMappingURL=WebXRBackgroundRemover.js.map